export const translations:any = {
    en: {
        newGosi:"The New System",
        otpValidation : "Only digits are allowed",
        fileSizeAlert:"The file size should not exceed 4 MB",
        fileTypeAlert:"The allowed file are: ['PDF', 'JPEG', 'JPG', PNG']",
        fileShare: "The file has been shared successfully", 
        workingHourMessageHeader:"We regret that we are unable to serve you at this time",
        sign_lang_label: "I am using sign language",
        sign_lang_val_yes: "Yes",
        sign_lang_val_no: "No",
        name: "Name",
        name_placeholder: "Name",
        mobile: "Mobile",
        mobile_placeholder: "Mobile",
        email: "email",
        email_placeholder: "email",
        nin_residence: "National ID \ Number ",
        nin_residence_placeholder: "National ID \ Number ",
        entity: "ُEntity",
        investor: "Investor",
        visitor: "Visitor",
        service_type: "Service Type",
        civil_militiray: "Retirement Systems (Civil/Military)",
        start_from_here: "Start Here",
        confirmation_approval: "Please check the pledge box to proceed",
        required_field: "Required Field",
        submit_btn: "Submit",
        save_btn: "send",
        confirmation_text: "I, as a user of this service, hereby pledge not to record this call and to maintain the confidentiality of the information discussed, in compliance with all provisions and regulations outlined in the Anti-Cybercrime Bylaw issued by Royal Decree No. M/17 dated 08/03/1428, and all relevant laws and regulations",
        record_text:"I pledge my commitment to the proper appearance, uniform, and place before and during the use of the service. and if otherwise, the call will be terminated, and the relevant regulations and instructions applied.",
        recordMessage:"In accordance with the Communications and Information Technology System, issued by the Council of Ministers' Decision No. (592) on the date 1/11/1443 AH, and its executive regulation regarding the protection of personal data of users in the telecommunications, space, and technology sectors, the calls is recorded for the purpose of improving the quality of the services provided. These recordings are protected and used only for training our employees and ensuring the provision of outstanding service. We guarantee the confidentiality and privacy of the information contained in these calls in accordance with the applicable laws and regulations",
        recordBold:"Disclaimer",
        validation_invalid_nin: "Invalid NIN",
        validation_invalid_mobile: "Phone number must be 10 digits",
        validation_only_digits: "Only Digits are allowed",
        validation_name: "Please enter a valid name",
        validation_email: "email is incorrect",
        our_branch: "SBC Virtual Assistant (Beta Launch)",
        application_name: "Endak",
        message: "This service facilitates conducting a virtual visit, and communicating with customer service representatives through video calls conveniently and easily",
        otp_header: "Please enter the verification code sent to the mobile number registered in Absher",
        otp_label: "otp code",
        resend_otp_btn: "Resend",
        for_better_service: "For a Better service",
        activate_mic_camera: "Please activate the Camera and MIC",
        mic: "Microphone",
        camera: "Camera",
        start_call_btn: "Start Call",
        waiting_message_1: "Our customer service representatives are serving other customers and you will be answered as soon as possible. Please do not refresh or close the page.",
        waiting_message_2: "",
        in_queue: "In Queue",
        exit_btn: "Exit",

        rating_message: "We hope you participate in this survey, which aims to measure your satisfaction and take advantage of your feedback that will effectively contribute to the team to improve your experience.",
        rating_q1: "How satisfied are you with the quality of the provided service?", 
        rating_q2: "How satisfied are you with the quality of the service provided by the employee?",
        rating_q3: "How satisfied are you with the quality of the service provided by the employee?",
        fully_satisfied: "Fully Satisfied",
        satisfied: "Satisfied",
        rating_equal: "Neutral",
        rating_unsatisfies: "Unsatisfied",
        fully_unsatisfied: "Fully Unsatisfied",
        unsatisfaction_reason: "Please mention the reason for leaving the virtual waiting room",
        notes_comments: "Notes ",
        after_rating_message_1: "Thank you for rating",
        after_rating_message_2: "Your satisfaction is our priority and we look forward to serving you better.",
        other: "Other",
        technical_error: "Technical Problem",
        waiting_time_is_long: "Long Waiting Time",
        exit_reason: "Exit Reason ?",
        service_rating_is_required: "Service rating is required",
        employee_rating_is_required: "Employee rating is required",
        digital_human_rating_is_required: "Digital human rating is required",
        unsatisfaction_reason_is_required: "Please insert unsatisfaction reason",
        abnormal_exit_reason_is_required: "Please insert exit reason",

        entity_option_1: "Ministry of Commerce ",
        entity_option_2: "Ministry of Municipal Rural Affairs & Housing ",
        entity_option_3: "Human Resource and Social Development ",
        entity_option_4: "Ministry of Investment ",
        entity_option_5: "General Organization for Social insurance ",
        entity_option_6: "Federation of Saudi Chamber ",
        entity_option_7: "Zakat, Tax and customs Authority",
        entity_option_8: "Ministry Of Education ",
        entity_option_9: "Saudi Business Center(Universal employee)",
        entity_option_10: "Ministry of Tourism",
        entity_option_11: "Compatibility",
        entity_option_12: "Verification",
        commercial_record: "Commercial Registration",
        commercial_record_placeholder: "Commercial Registration",
        service_language: "Preferred Language",
        arabic: "Arabic",
        english: "English  ",
        select: "Select",
        waitMsgL1: "We appreciate your waiting. The number of customers waiting ahead of you:",
        waitMsgL2: "a customer service agent will assist you soon....",
        waitMsgL3: "Number of Customers waiting:",
        waitMsgL4: "customers ",
        digit10Msg: "Ten Digits must be entered",
        chat_btn1: "Submit",
        thanksMsgL1: "Thank you for participating with us to enhance our services.",
        thanksMsgL2: "",
        chatPlaceholder: "Type here…",
         //new addition
        conv_instant_h: "Chat Bot",
        urg_call_mssg: "In a hurry and want us to serve you now? Try our Chat Bot!",
        urg_btn_mssg: "Start the conversation",
        virtual_head: "The Virtual Visit",
        insurance_sys: "Insurance Systems",
        individuals: "Individuals",
        microphone: "Microphone",
        start_comm: "Start",
        estab_admin:"Change the Branch Account Manager",
        estab_admin_messg: "This service allows the establishers to modify the structure of their facilities by separating a branch from the main facility, or linking a facility with another facility through the authority of the branch account manager",
        report_eq: "Report an Occupational Injury",
        report_eq_messg: "This service allows reporting an occupational injury that occurred to one of the contributors of the assigned treatment entity or the competent insurance office",
        delink_link: " Link/Delink Establishments",
        delink_link_messg: "This service allows the establishers to modify the structure of their establishments by separating a branch from the main establishment, or linking an establishment with another establishment through the authority of the branch account manager", 
        add_saudi: "Add a Non-Saudi Contributor",
        add_saudi_messg: "This service allows the addition of (non-Saudi contributor/Gulf contributor/non-Saudi contributor with a distinguished residence/private expatriate/contributor from the displaced tribes under the establisher).",
        tract_req: "Track Requests",
        tract_req_messg: "This service allows the user to follow up on applications or transactions submitted to the General Organization for Social Insurance through the service centers, the website and applications of the organization for smart devices",
        visit_emp: "Visit the Customer Service Representative",
        visit_emp_messg: "This service allows the establisher to communicate with the customer service representative directly through a video call",
        business_own: "Establishments",
        service_virtual_visit: "This service allows for the possibility of holding a virtual visit and communicating with the customer service employee via video communication with complete ease",
        unavaibility_message: "Dear customers, we apologize that the service is currently unavailable, and we are happy to serve you during working hours",
        date_avail1: "From Sunday to Thursday between 08:00 am to 06:00 pm",
        date_avail2: "Friday between 02:00 pm to 06:00 pm",
        date_avail3: "Saturday between 09:00 am to 02:00 pm", 
        date_avail4: "From Sunday to Thursday between 08:00 am to 02:00 pm",
        client: "Customer",
        message_unavailable: "Dear customer, Sorry, the browser used is not supported, we hope you change the browser and use Google Chrome Thank you for contacting us through the virtual visit service",
        message_waiting_unavailable: "Dear customer, we appreciate your time, and we inform you that all employees are busy serving other customers. We hope that you will try again later, and we will be happy to serve you through other communication channels. You can benefit from our electronic services by visiting",
        service_page_content: "Services page",
        start_new_conv: "Start a new conversation",
        insurance_assistant: "Your insurance assistant",
        thanks_filling_form: "Thank you for filling out the form",
        popular_ques: "Popular Questions",
        merge_descision: "The merger decision does not change or affect the mechanism for applying for services and transactions.",
        insurance_system: "Is there a change in the procedures for applying for combining subscription periods (exchanging benefits between the civil and military retirement systems and the insurance system) between the two institutions?",
        merge_periods: "The merger does not affect the application procedures for adding periods.",
        merge_institution: "Does the merger affect the workflow of current transactions at the two institutions?",
        merge_transaction: "The merger does not impact the existing transactional workflow of the two institutions.",
        insurance_waiting_screen: "New insurance waiting screen",
        national_day_message: "Dear customers, we congratulate you on the founding day of the Kingdom of Saudi Arabia, and we inform you that the service is currently not available Work will resume starting Thursday, February 23, 2023 AD - at 8:00 AM. To benefit from our electronic services, we are happy for you to visit our page.",
       oragnization_message: "The organization's electronic services",
       complete_transaction: "You can also complete your transaction by visiting the links below.",
       customer_care:"Customer Care",
       for_better_service2:  "For a Better service",
       insurance_requests: "Follow up on insurance system requests",
       retirement_requests: "Follow up on requests for retirement systems",
       insurance_system2: "Taking care of insurance system clients",
       retirement_system2: "Taking care of retirement system clients",
       customer_service_represntation: "Please writing your inquiry and a customer service representative will respond to you as soon as possible",
       share_opinion: "Please share your opinion with us, to help us improve our performance and serve you better",
       upload_file: "Please upload the file in (pdf, .png, .jpg, .jpeg) format only, without the file size exceeding 2 MB.",
       opinion_matter: "your opinion matters",
       submit_inquiry: "Submit an inquiry",
       answer_inquiry: "We are happy to serve you and answer your inquiries.",
       welcome: "welcome",
       chat_unav: "Sorry, the instant chat service is currently unavailable",
       poc3_option1:"Inquiries",
       poc3_option2:"Suggestions",
        poc3_option3:"Permits",
       vertualVisit_title:"The Virtual Visit",
       backTohome:"Back to the beginning of the service",
       vertualVisit_description:"This service facilitates conducting a virtual visit, and communicating with customer service representatives through video calls conveniently and easily",
       aval_workHour: "We will only be available to serve you during business hours",
       displayActivateAlert: "In order for us to serve you, please activate your camera and microphone",
       notSentOtpAlert: "The verification code could not be sent, please try again later",
       unsupportedMessage:"Dear Valued Client,<br/>To ensure you have the best possible experience using our service, we kindly recommend using a supported web browser.<br/>Here is a list of compatible browsers for different devices:",
        unsupportedMessageP1:"<b> <i class=\"fa fa-circle\" aria-hidden=\"true\"></i> Web:</b> Microsoft Edge, Google Chrome, and Google Search",
        unsupportedMessageP2:"<b> <i class=\"fa fa-circle\" aria-hidden=\"true\"></i> iOS:</b> Apple Safari and Google Search",
        unsupportedMessageP3:"<b><i class=\"fa fa-circle\" aria-hidden=\"true\"></i> Android:</b> Google Search, Google Chrome and the built-in Android browser (may vary by device)",
        unsupportedMessagLast:"Please note that the service does not work when using unsupported browsers. We appreciate your understanding and cooperation."

    },
    ar: {
      vertualVisit_description:"تتيح هذه الخدمة امكانية عقد زيارة افتراضية والتواصل مع موظف خدمة العملاء عبر الاتصال المرئى بكل سهولة ويسر",
        vertualVisit_title:"خدمة الزيارة الافتراضية",
      poc3_option1:"استفسارات",
      poc3_option2:"اقتراحات",
        poc3_option3:"تراخيص ",
        newGosi: "النظام الجديد",
        backTohome:"العودة  إلى بداية الخدمة",
        unsupportedMessage: "عزيزنا العميل،<br />لضمان حصولك على أفضل تجربة عند استخدام خدمتنا، نوصي باستخدام متصفح ويب مدعوم.<br />الرجاء إيجاد المتصفحات المدعومة أدناه: ",
        unsupportedMessageP1:"<i class=\"fa fa-circle\" aria-hidden=\"true\"></i><b> الويب:</b> مايكروسوفت ايدج، محرك بحث جوجل، وجوجل كروم  ",
        unsupportedMessageP2:"<i class=\"fa fa-circle\" aria-hidden=\"true\"></i><b>IOS: </b> سفاري الخاص بشركة أبل ومحرك بحث جوجل ",
        unsupportedMessageP3:"<i class=\"fa fa-circle\" aria-hidden=\"true\"></i><b> أندرويد:</b> محرك بحث جوجل، جوجل كروم، ومتصفح أندرويد (قد يختلف حسب الجهاز) ",
        unsupportedMessagLast:"يرجى ملاحظة أن الخدمة لا تعمل عند استخدام متصفحات غير مدعومة. نقدر تفهمكم وتعاونكم.",
        otpValidation: "مسموح فقط استخدام الأرقام",
        fileSizeAlert:"حجم الملف لا يزيد عن 4 ميجا",
        fileTypeAlert:"مسموح بهذه الملفات فقط ['pdf','jpeg','png','jpg']",
        fileShare:"تم مشاركة الملف بنجاح",
        workingHourMessageHeader: "  نأسف لعدم القدرة على خدمتكم في هذا الوقت   ",
        sign_lang_label: "انا أتحدث لغة الاشارة ",
        sign_lang_val_yes: "نعم",
        sign_lang_val_no: "لا",
        name: "الاسم",
        name_placeholder: "الاسم",
        mobile: "رقم الجوال",
        mobile_placeholder: "رقم الجوال",
        email: "الإيميل",
        email_placeholder: "الإيميل",
        nin_residence: "الهوية الوطنية / الاقامة",
        nin_residence_placeholder: "الهوية الوطنية / الاقامة",
        entity: "الجهة",
        investor: "مستثمر",
        visitor: "زائر",
        service_type: "نوع الخدمة",
        civil_militiray: "أنظمة التقاعد(المدنى / العسكرى)",
        start_from_here: "ابدأ من هنا",
        confirmation_approval: "الرجاء الموافقه على الإقرار ",
        required_field: "هذا الحقل مطلوب",
        submit_btn: "استمرار",
        save_btn: "ارسال",
        confirmation_text: " أتعهد انا مستخدم هذه الخدمة بعدم تسجيل هذه المكالمة وأن احافظ على سرية البيانات الواردة فيها التزاماً بكافة الأحكام والقواعد الواردة في نظام مكافحة الجرائم المعلوماتية الصادر بالمرسوم الملكي رقم م/17 وتاريخ 1428/03/08, وبجميع الأنظمة ذات الصلة ",
        record_text:"أتعهد بالالتزام بالمظهر اللائق والزي الرسمي والمكان المناسب قبل وأثناء الاستفادة من الخدمة، وفي حال مخالفة ذلك سيتم  إنهاء الاتصال وتطبيق الأنظمة والتعليمات ذات الصلة ",
        validation_invalid_nin: "رقم الهوية غير صحيح",
        validation_invalid_mobile: "يجب أن يكون رقم الجوال من 10 أرقام",
        validation_only_digits: " غير مسموح باستخدام الحروف",
        validation_name: "من فضلك أدخل اسمًا صحيحًا",
        validation_email: "الإيميل غير صحيح",
        our_branch: "الاتصال المرئي (إطلاق تجريبي)",
        application_name: "عندك",
        message: "تتيح هذه الخدمة امكانية عقد  زيارة افتراضية  والتواصل مع موظف خدمة العملاء عبر الاتصال المرئى بكل سهولة ويسر",
        recordBold: "ملاحظة",
        recordMessage:"اتباعًا لنظام الاتصالات وتقنية المعلومات الصادر بقرار مجلس الوزراء رقم (592) بتاريخ 1443/11/1هـ ولائحته التنفيذية اتجاه حماية البيانات الشخصية للمستخدمين في قطاع الاتصالات والفضاء والتقنية؛ سنقوم بتسجيل المكالمات الهاتفية لأغراض تحسين جودة الخدمات المقدمة. هذه التسجيلات محمية وتستخدم فقط لتدريب موظفينا وضمان تقديم خدمة متميزة، ونضمن الحفاظ على سرية وخصوصية المعلومات الواردة في هذه المكالمات وفقًا للقوانين والأنظمة المتبعة",
        otp_header: "فضلًا أدخل رمز التحقق المرسل على رقم الجوال المسجل في أبشر",
        otp_label: "رمز التحقق",
        resend_otp_btn: "اعادة ارسال رمز التحقق",
        for_better_service: "لخدمتك بشكل أفضل ",
        activate_mic_camera: "يرجى تفعيل جهاز الكاميرا والصوت",
        mic: "جهاز الصوت",
        camera: "جهاز الكاميرا",
        start_call_btn: "بدء الاتصال",
        waiting_message_1: "موظفينا في خدمة عملاء آخرين وسيتم تحويلك في أسرع وقت ممكن. الرجاء عدم تحديث أو إغلاق الصفحة",
        waiting_message_2: "",
        in_queue: "أمامك فى الانتظار",
        exit_btn: "خروج",

        rating_message: "نأمل منك المشاركة فى هذا الاستبيان الذى يهدف إلى قياس رضاك والاستفادة من ملاحظاتك التى ستساهم بشكل فعّال فى فريق العمل لتحسين تجربتك",
        rating_q1: " ما مدى رضاك عن جودة الخدمة المقدمة؟",
        rating_q2: "ما مدى رضاك عن جودة الخدمة المقدمة من الموظف؟",
        rating_q3: "ما مدى رضاك عن جودة الخدمة المقدمة من الموظف؟",
        fully_satisfied: "راضى تماما",
        satisfied: "راضى",
        rating_equal: "محايد",
        rating_unsatisfies: "غير راضى",
        fully_unsatisfied: "غير راضى تماما",
        unsatisfaction_reason: "فضلًا أذكر سبب خروجك من غرفة الانتظار الافتراضية",
        notes_comments: "ملاحظات واقتراحات",
        after_rating_message_1: "شكرا لمشاركتكم",
        after_rating_message_2: "رضاكم محل اهتمامنا ونتطلع لخدمتكم بشكل افضل",
        other: "أخرى",
        technical_error: "مشكلة تقنية",
        waiting_time_is_long: "وقت الانتظار طويل",
        exit_reason: "فضلا اذكر سبب خروجك من الانتظار",
        service_rating_is_required: "برجاء تقييم الخدمة",
        employee_rating_is_required: "برجاء تقييم الموظف",
        digital_human_rating_is_required: "رجاء تقييم الانسان الرقمى",
        unsatisfaction_reason_is_required: "الرجاء ذكر عدم رضاك عن الخدمة",
        abnormal_exit_reason_is_required: "الرجاء ذكر سبب الخروج من الانتظار",

        entity_option_1: "وزارة التجارة",
        entity_option_2: "وزارة الشؤون البلدية والقروية والإسكان",
        entity_option_3: "وزارة الموارد البشرية والتنمية الاجتماعية",
        entity_option_4: "وزارة الاستثمار",
        entity_option_5: "المؤسسة العامة للتأمينات الاجتماعية",
        entity_option_6: "اتحاد الغرف السعودية",
        entity_option_7: "هيئة الزكاة والضريبة والجمارك",
        entity_option_8: "وزارة التعليم",
        entity_option_9: "المركز السعودى للأعمال (الموظف الشامل)",
        entity_option_10: "وزارة السياحة",
        entity_option_11: "الموائمة",
        entity_option_12: "التوثيق",

        commercial_record: "السجل التجارى",
        commercial_record_placeholder: "السجل التجارى",
        service_language: "لغة التواصل",
        arabic: "اللغة العربية",
        english: "اللغة الانجليزية",
        select: "اختر",
        waitMsgL1: "نقدر لك انتظارك، أمامك في الانتظار:",
        waitMsgL2: "ممثل خدمة العملاء فى خدمة عملاء اخرين يرجى الانتظار ... ",
        waitMsgL3: "أمامك فى الانتظار : ",
        waitMsgL4: "عملاء ",
        digit10Msg: "يجب إدخال 10 أرقام",
        chat_btn1: "ارسال",
        thanksMsgL1: "شكرا لمشاركتكم",
        thanksMsgL2: "شكرا لإسهامكم معنا في تطوير خدماتنا ",
        chatPlaceholder: "اكتب هنا...",
        //new addition
        conv_instant_h: "المحادثة الفورية",
        urg_call_mssg: "مستعجل ودك نخدمك الان ! جرب المحادثة الفورية",
        urg_btn_mssg: "بدء المحادثة",
        virtual_head: "خدمة الزيارة الافتراضية",
        insurance_sys: "أنظمة التأمينات",
        individuals: "الأفراد", 
        microphone: "ميكروفون",
        start_comm: "بدء الاتصال",
        estab_admin:"تغيير مدير حساب الفروع",
        estab_admin_messg: "تتيح هذه الخدمة تغيير مدير حساب الفروع للمنشأة في تأميناتي أعمال",
        report_eq: "الإبلاغ عن إصابة عمل",
        report_eq_messg: "تتيح هذه الخدمة الإبلاغ عن إصابة عمل وقعت لأحد  المشتركين لجهة العلاج المخصصة أو لمكتب التأمينات المختص​",
        delink_link: 'فصل/ربط المنشآت',
        delink_link_messg: "تتيح هذه الخدمة لصاحب العمل تعديل هيكل المنشآت لديه وذلك بفصل فرع عن المنشأة الرئيسية أو ربط منشأة مع منشأة أخرى​ من خلال صلاحية مدير حساب الفروع",
        add_saudi: "تسجيل مشترك غير سعودي",
        add_saudi_messg: "تتيح هذه الخدمة إضافة (مشترك غير سعودي / مشترك خليجي / مشترك غير سعودي ذو إقامة مميزة / وافد خاص / مشترك من القبائل النازحة) لدى صاحب العمل​.",
        tract_req: "متابعة الطلبات",
        tract_req_messg: "تتيح هذه الخدمة متابعة الطلبات أو المعاملات المقدمة للمؤسسة العامة للتأمينات الاجتماعية عبر مراكز الخدمة، الموقع الالكتروني، تطبيقات المؤسسة للأجهزة الذكية​.",
        visit_emp: "مقابلة موظف الزيارة",
        visit_emp_messg: "إتاحة التواصل لأصحاب العمل مع ممثل خدمة العملاء بشكل مباشر عبر الاتصال المرئي",
        business_own: "اصحاب العمل",
        service_virtual_visit: "تتيح هذه الخدمة امكانية عقد زيارة افتراضية التواصل مع موظف خدمة العملاء عبر الاتصال المرئى بكل سهولة ويسر",
        unavaibility_message: "عملائنا الأعزاء نعتذر منكم الخدمة غير متوفرة حاليا وتسعدنا خدمتكم خلال أوقات العمل",
        date_avail1: " من الاحد الى الخميس بين الساعة 08:00 صباحاً الى الساعة 06:00 مساءً",
        date_avail2: "الجمعة بين الساعة 02:00 مساءً الى الساعة 06:00 مساءً",
        date_avail3: "السبت بين الساعة 09:00 صباحاً الى الساعة 02:00 مساءً",
        date_avail4: "من الاحد الى الخميس بين الساعة 08:00 صباحاً الى الساعة 02:00 مساءً",
        client: "عميل",
        message_unavailable: "  عزيزي العميل،  عذراً  المتصفح المستخدم غير مدعوم ، نأمل تغيير المتصفح واستخدام Google Chrome   شكراً لتواصلك معنا عبر خدمة الزيارة الافتراضية",
        message_waiting_unavailable: "عميلنا العزيز، نقدر وقتك، و نفيدك بأن جميع الموظفين مشغولون في خدمة عملاء آخرين. نأمل منك المحاولة في وقت لاحق وتسعدنا خدمتك عبر قنوات التواصل الاخرى و يمكنك الاستفادة من خدماتنا الالكترونية وذلك بزيارة",
        service_page_content: " صفحة الخدمات",
        start_new_conv: "بدء محادثة جديدة",
        insurance_assistant: "مساعدك التأميني",
        thanks_filling_form: "شكرًا لتعبئتك النموذج",
        popular_ques: "الأسئلة الشائعة",
        retri_mechanism: "هل هناك تغير في آلية التقديم على التقاعد؟",
        merge_decision: " قرار الدمج لا يغير أو يؤثر على آلية التقديم على الخدمات والمعاملات",
        insurance_system: "هل هناك تغير في اجراءات التقديم على ضم مدد الاشتراك (تبادل المنافع بين نظامي التقاعد المدني والعسكري ونظام التأمينات) بين المؤسستين؟",
        merge_periods: "لا يؤثر الدمج على اجراءات التقديم لضم المدد.",
        merge_institution: " هل عملية الدمج توثر على سير عمل المعاملات الحالية لدى المؤسستين؟",
        merge_transaction:" لا يؤثر الدمج على سير عمل المعاملات الحالية لدى المؤسستين.",
        insurance_waiting_screen: "شاشة انتظار التأمينات الجديدة ",
        national_day_message: "عملائنا الأعزاء نهنئكم بيوم التأسيس للمملكة العربية السعودية، و نفيدكم أن الخدمة غير متوفرة حالياً  وسيستأنف العمل ابتداء من يوم الخميس الموافق 23-02-2023 م – الساعة 8:00  صباحاً وللاستفادة من خدماتنا الالكترونية نسعد بزيارتكم لصفحة",
        oragnization_message: "الخدمات الإلكترونية للمؤسسة",
        complete_transaction: "يمكنك أيضًا إتمام معاملتك عن طريق زيارة الروابط أدناه.",
        customer_care: "العناية بالعملاء",
        for_better_service2: "لخدمتك بشكل أفضل،الرجاء الاختيار :",
        insurance_requests:"متابعة طلبات نظام التأمينات",
        retirement_requests: "متابعة طلبات أنظمة التقاعد",
        insurance_system2: "العناية بعملاء نظام التأمينات",
        retirement_system2: "العناية بعملاء أنظمة التقاعد",
        customer_service_represntation: "ابدأ بكتابة استفسارك وسيقوم ممثل خدمة العملاء بالرد عليك في أقرب وقت",
        share_opinion: "فضلاً شاركنا رأيك، لمساعدتنا على تحسين أدائنا وخدمتك بشكل أفضل",
        upload_file: "الرجاء رفع الملف بصيغة (pdf, .png, .jpg, .jpeg) فقط دون تجاوز حجم الملف 2 ميغابايت",
        opinion_matter: "رأيك يهمنا",
        submit_inquiry: "تقديم استفسار",
        answer_inquiry: "يُسعدنا خدمتك وتقديم الإجابة على استفساراتك.",
        welcome: "مرحبا",
        chat_unav: "عذرًا، خدمة المحادثة الفورية غير متاحه حاليًا",
        aval_workHour: "سنكون متاحين لخدمتك فقط خلال أوقات العمل",
        displayActivateAlert: "حتى نتمكن من خدمتك الرجاء تفعيل الكاميرا والميكروفون",
        notSentOtpAlert: "تعذر ارسال رمز التحقق، الرجاء المحاولة في وقت لاحق",
    },
};






document.addEventListener("DOMContentLoaded", () => {


    let language = localStorage.getItem("lang")

    if (language == null) {
        language = "ar";
    }

    setLanguage(language);
});

const setLanguage = (language: any) => {

    if (language == null) {
        return;
    }
    const languageSelector = document.getElementById("languageSelector") as HTMLInputElement;
     if(languageSelector) languageSelector.value = language;
    localStorage.setItem("lang", language);

    document.dir = language === "ar" ? "rtl" : "ltr";
    console.log("kiro", document)
    const elements = document.querySelectorAll("[data-i18n]");

    const bodyElement = document.body;
     
   // bodyElement.style.fontFamily = language === "ar" ? "GE SS Two" : "DIN_Next_LT_Arabic";
   
const spanElements = document.querySelectorAll('span');
const divElements = document.querySelectorAll('div');
const h2Elements = document.querySelectorAll('h2');
const pElements = document.querySelectorAll('p');

// Example: Add a red border to each selected element

    if(language === "ar"){
        console.log("Sdsfdsf")
        bodyElement.style.setProperty('font-family', 'GESSTwo');
        spanElements.forEach((span) => {
            span.style.fontFamily = 'GESSTwo';
          });
          
          divElements.forEach((div) => {
            div.style.fontFamily = 'GESSTwo';
          });
          
          h2Elements.forEach((h2) => {
            h2.style.fontFamily = 'GESSTwo';
          });
          
          pElements.forEach((p) => {
            p.style.fontFamily = 'GESSTwo';
          });
    }
    else{
        console.log("htm;l")
        bodyElement.style.setProperty('font-family', 'DIN_Next_LT_Arabic', 'important');
        spanElements.forEach((span) => {
            span.style.fontFamily = 'DIN_Next_LT_Arabic';
          });
          
          divElements.forEach((div) => {
            div.style.fontFamily = 'DIN_Next_LT_Arabic';
          });
          
          h2Elements.forEach((h2) => {
            h2.style.fontFamily = 'DIN_Next_LT_Arabic';
          });
          
          pElements.forEach((p) => {
            p.style.fontFamily = 'DIN_Next_LT_Arabic';
          });
    }
   

    elements.forEach((element: any) => {
        const translationKey = element.getAttribute("data-i18n");
        element.textContent = translations[language][translationKey];

        element.innerHTML = translations[language][translationKey];
        element.placeholder = translations[language][translationKey];
    });

    let logoBox = document.getElementById("internalLogo") as HTMLDivElement;
   // let logoBoxEN = document.getElementById("internalLogoEN") as HTMLDivElement;
   if (logoBox) {
    logoBox.style.display = language === "ar" ? "block" : "none";
    }

  //  let content_container = document.getElementById("content-container");
    let admin_messageAR = document.getElementById("admin_message");
    let admin_messageEN = document.getElementById("admin_messageEN");

    if (admin_messageEN !== null && admin_messageAR !== null) {
        if (language === "ar") {
            admin_messageEN.style.display = "none";
            admin_messageAR.style.display = "";
        }
        else {
            admin_messageEN.style.display = "";
            admin_messageAR.style.display = "none";


        }
    }
    //let languageBar = document.getElementById("languageBar");
    // if (content_container != null) {
    //     content_container.style.direction = language === "ar" ? "rtl" : "ltr";
    // }
    // if (languageBar != null) {
    //     languageBar.style.direction = language === "ar" ? "rtl" : "ltr";
    // }



    if (language === "ar") {
        document.body.style.textAlign = "right";
        document.body.style.fontFamily = "GE SS Two";

    } else {
        document.body.style.textAlign = "left";
        document.body.style.removeProperty("font-family");
        document.body.style.fontFamily = "";

    }
    
    //changeLanguageImagesInputForm(language);
    //let content_1_div = document.getElementById("content_1_div") as HTMLElement;

    // if(language === "ar"){
    //     // content_6_div.style.backgroundImage = "url('your_image_url_here')";
    //     // content_5_div.style.backgroundImage = "url('your_image_url_here')";
    //     // content_4_div.style.backgroundImage = "url('your_image_url_here')";
    //     // content_3_div.style.backgroundImage = "url('your_image_url_here')";
    //     // content_2_div.style.backgroundImage = "url('your_image_url_here')";
    //     content_1_div.style.backgroundImage = "url('../src/assets/new_gosi_links/change_branch_manager.png')";
    // }else if(language === "en"){
    //     content_1_div.style.backgroundImage = "url('../src/assets/new_gosi_links/en/change_branch_manager.png')";
    // }
};


// const changeLanguageImagesInputForm = (language: any) =>{
//     // let content_6_div = document.getElementById("content_6_div") as HTMLElement;
  

//     // let content_5_div = document.getElementById("content_5_div") as HTMLElement;
   

//     // let content_4_div = document.getElementById("content_4_div") as HTMLElement;
  

//     // let content_3_div = document.getElementById("content_3_div") as HTMLElement;
  


//     // let content_2_div = document.getElementById("content_2_div") as HTMLElement;



//     let content_1_div = document.getElementById("content_1_div") as HTMLElement;

//     if(language === "ar"){
//         // content_6_div.style.backgroundImage = "url('your_image_url_here')";
//         // content_5_div.style.backgroundImage = "url('your_image_url_here')";
//         // content_4_div.style.backgroundImage = "url('your_image_url_here')";
//         // content_3_div.style.backgroundImage = "url('your_image_url_here')";
//         // content_2_div.style.backgroundImage = "url('your_image_url_here')";
//         content_1_div.style.backgroundImage = "url('../src/assets/new_gosi_links/change_branch_manager.png')";
//     }else if(language === "en"){
//         content_1_div.style.backgroundImage = "url('../src/assets/new_gosi_links/en/change_branch_manager.png')";
//     }
// }

export default setLanguage;